var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#959595"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.47 5.47c.266-.267.683-.29.976-.073l.084.073L8 8.939l3.47-3.47c.266-.266.683-.29.976-.072l.084.073c.267.266.29.683.073.976l-.073.084-4 4c-.266.267-.683.29-.976.073l-.084-.073-4-4c-.293-.293-.293-.767 0-1.06z",
    transform: "translate(-39 -1) translate(39 1)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDownGrey);
export default __webpack_public_path__ + "static/media/ic-chevron-down-grey.2b4ebb8757d4948b00e0f4823433b434.svg";
export { ForwardRef as ReactComponent };